export default __webpack_public_path__ + "static/media/ic_console.8fc3c843.svg";